import Enumerator from '../global/Enumerator';

export const contactGenders = ['none', 'male', 'female', 'other'];

export class ContactGender extends Enumerator {
  static default() {
    return this.of('none');
  }
}

ContactGender.initEnum({
  none: {
    get title() {
      return 'None selected';
    }
  },
  male: {
    get title() {
      return 'Male';
    }
  },
  female: {
    get title() {
      return 'Female';
    }
  },
  other: {
    get title() {
      return 'Other';
    }
  }
});

export default {
  contactGenders,
  ContactGender
};
